<template>
    <div class="card-dokter-appointment" :class="classBorder ? 'mb-3' : ''">
        <p class="fs-38 fw-700 c-primary mb-0 ellipsis-dokter">{{detailDokter.name}}</p>
        <p class="fs-32 fw-400 c-primary mb-0">
          {{detailDokter.poli}}
          <template v-if="detailDokter.time"> | {{detailDokter.time}}</template>
        </p>
        <p class="fs-32 fw-400 c-primary mb-0" v-if="payorText">{{ $l.detectLanguage(payorText) }}</p>
    </div>
</template>

<script>
export default {
  props: {
    detailDokter: {
      type: Object,
      default: () => {}
    },
    classBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    payorText () {
      if (this.detailDokter.jenisPembayaran === 'ASURANSI') return 'payorInsurance'
      else return 'payorSelf'
    }
  }
}
</script>

<style scoped>
  .card-dokter-appointment{
    background-color: var(--biru-hospital-E);
    border-radius: 16px;
    padding: 20px 24px;
  }
</style>
